import FiltersMenu from './FiltersMenu';

export default FiltersMenu;
